import type { SVGProps } from "react";
export interface BrainAIIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BrainAIIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BrainAIIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M16.26 15.874c.746 0 1.468.268 2.034.753l1.568 1.345q.303-.096.639-.097l.216.01a2.125 2.125 0 1 1-2.332 2.333l-.01-.219.01-.216.015-.102-1.57-1.346a.88.88 0 0 0-.57-.21H12a1.125 1.125 0 1 1 0-2.25zm4.957-5.988a2.125 2.125 0 0 1-.217 4.24 2.12 2.12 0 0 1-1.8-1.001H12a1.125 1.125 0 1 1 0-2.25h7.2c.375-.6 1.04-1 1.8-1zm-.5-8a2.126 2.126 0 1 1-.855 4.14l-1.568 1.346a3.13 3.13 0 0 1-2.034.753H12a1.125 1.125 0 0 1 0-2.25h4.26a.88.88 0 0 0 .57-.21l1.57-1.348q-.008-.05-.015-.1L18.375 4l.01-.218A2.126 2.126 0 0 1 20.5 1.875z"
      />
      <path
        fill={color}
        d="M10.857 4.117a1.25 1.25 0 0 0-.343-.569 1.44 1.44 0 0 0-1.026-.423c-.421 0-.768.172-1.016.42-.268.268-.36.557-.36.705 0 .491-.317.925-.786 1.072-.904.285-1.377.848-1.377 1.661 0 .428-.243.82-.627 1.01-.891.44-1.415 1.475-.956 2.573.192.46.058.992-.328 1.307-.64.52-.91 1.145-.913 1.748-.002.612.274 1.333.983 2.015.22.212.346.506.346.812 0 .763.241 1.291.565 1.623.283.289.695.498 1.25.546l.246.01.199.018c.456.082.824.44.908.91.144.809.91 1.32 1.616 1.32a1.97 1.97 0 0 0 1.135-.364c.244-.184.445-.451.49-.893l.011-.201.002-15.167zm2.267 15.3-.006.242c-.067 1.186-.628 2.075-1.391 2.65-.773.581-1.712.816-2.49.816-1.356 0-2.911-.803-3.57-2.32-.87-.152-1.65-.541-2.258-1.162-.695-.713-1.096-1.66-1.186-2.722C1.35 15.949.87 14.795.875 13.61c.005-1.087.418-2.112 1.173-2.945-.4-1.788.41-3.428 1.704-4.345.219-1.386 1.119-2.346 2.234-2.881C6.382 2.096 7.719.875 9.488.875c2.114 0 3.638 1.747 3.638 3.375z"
      />
    </svg>
  );
}
